import {StyleSheet} from 'react-native';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.background,
    },
    headerView: {
      marginTop: 30,
      marginHorizontal: 24,
    },
    contentContainer: {
      flex: 1,
    },
    typeContainer: {
      flex: 1,
      marginTop: 32,
      paddingHorizontal: 24,
    },
    buttonsContainer: {
      flexDirection: 'row',
      marginBottom: 16,
      marginHorizontal: 24,
      marginTop: 24,
    },
    leftButton: {
      flex: 1,
    },
    rightButton: {
      flex: 1,
      marginLeft: 16,
    },
  });

export default makeStyles;
